import type { SVGProps } from "react";

const CardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1.66667"
        y="4.16667"
        width="16.6667"
        height="11.6667"
        rx="1.66667"
        stroke="currentColor"
        strokeWidth="1.45833"
      />
      <path d="M1.66667 8.33333H18.3333" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 11.6667H8.33333" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CardIcon;
